import {Checkbox, Text} from '@chakra-ui/react';
import React, {ReactNode} from 'react';
import {CHECKBOX_BLUE_SX} from './FilterBarStyles';

// Checkbox bleue partagée entre tous les filtres FilterBar (popovers desktop, drawer mobile,
// FromageFilterContent...). Applique le style commun CHECKBOX_BLUE_SX et un label bleu —
// évite de redéfinir le sx et le Text à chaque checkbox.

interface FilterBarBlueCheckboxProps {
  isChecked: boolean;
  isDisabled?: boolean;
  onChange: (checked: boolean) => void;
  children: ReactNode;
}

export const FilterBarBlueCheckbox: React.FC<FilterBarBlueCheckboxProps> = ({
  isChecked,
  isDisabled,
  onChange,
  children,
}) => (
  <Checkbox
    borderColor='gray.light'
    size='sm'
    isChecked={isChecked}
    isDisabled={isDisabled}
    onChange={(e) => {
      onChange(e.target.checked);
    }}
    sx={CHECKBOX_BLUE_SX}
  >
    <Text
      color='blue.main'
      whiteSpace='nowrap'
    >
      {children}
    </Text>
  </Checkbox>
);
